'use client'

import React from 'react';
import Slider from 'react-slick';
import s from './HomeSlider.module.scss';
import ContentfulImage from '../ContentfulImage';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { HomeSliderProps } from '../../constants/types';

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const HomeSlider: React.FC<HomeSliderProps> = ({ caseStudiesSliderImages }) => {
  return (
    <div className='home-slider' data-testid='homeSlider'>
      <Slider {...settings} className="leading-companies-slider">
        {caseStudiesSliderImages.map((image) => (
            <div className="slider-img" key={image.title || ''}>
              <ContentfulImage
                fluid={image.fluid}
                alt={image.title || ''}
                className={s.img}
                dataTestId='contentfulImage'
              />
            </div>
          ))}
      </Slider>
    </div>
  );
};
export default HomeSlider;
